module.exports = __webpack_public_path__ + "static/img/new3-8pD6ochW.e35b4da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new3-8pD6ochW.png
// module id = 99+1
// module chunks = 16